export enum Experiments {
  SHOW_LAST_NEXT_CHARGE = 'specs.subscriptionsTpa.ShowLastNextCharge',
  EXPOSE_NEW_FEATURE = 'specs.premium.subscriptions-tpa.exposeNewFeature',
  VERIFY_GRACE_PERIOD_BEFORE_PAY_NOW = 'specs.premium.subscriptions-tpa.VerifyGracePeriodBeforePayNow',
  USE_INITIATE_PAYMENT_METHOD_SETUP = 'specs.premium.subscriptions-tpa.UseInitiatePaymentMethodSetup',
  UX_CHANGES = 'specs.premium.subscriptions-tpa.UxChanges',
}
